import {
  GET_SERVICES,
  SERVICES_ERROR,
  SERVICES_RECEIVED,
  SERVICE_SELECTED,
  SET_OFFER_PRODUCT_SERVICES,
  RESET,
} from './constants';

/**
 *
 * @returns {{type: *}}
 */
export const getServices = () => ({
  type: GET_SERVICES,
});

/**
 *
 * @param services
 * @returns {{services: *, type: *}}
 */
export function servicesLoaded(services) {
  return {
    type: SERVICES_RECEIVED,
    services,
  };
}

/**
 *
 * @param error
 * @returns {{type: *, error: *}}
 */
export function servicesError(error) {
  return {
    type: SERVICES_ERROR,
    error,
  };
}

/**
 *
 * @param services
 * @returns {{services: *, type: *}}
 */
export function servicesSelected(services) {
  return {
    type: SERVICE_SELECTED,
    services,
  };
}

/**
 *
 * @param services
 * @returns {{services: *, type: *}}
 */
export function setProductServices(services) {
  return {
    type: SET_OFFER_PRODUCT_SERVICES,
    services,
  };
}

/**
 *
 * @returns {{type: *}}
 */
export function resetStore() {
  return {
    type: RESET,
  };
}
